export const PRICING_LIST_PDF = require("./ARZFoodServicePricingList.pdf");